export const BUILDER_DRAFT_KEY = 'casa_pwa_builder_session';

export const clearBuilderDrafts = () => {
  try {
    Object.keys(sessionStorage)
      .filter((key) => key === BUILDER_DRAFT_KEY || key.startsWith(`${BUILDER_DRAFT_KEY}:`))
      .forEach((key) => sessionStorage.removeItem(key));
  } catch {
    return;
  }
};
